import React from 'react';
import { Box, Button, TextField } from '@mui/material';

const PlannerSessionGoalsEditor = ({ newGoal, setNewGoal, handleAddGoal }) => {
  return (
    <Box mt={2}>
      <TextField
        fullWidth
        label="New Goal"
        value={newGoal}
        onChange={(e) => setNewGoal(e.target.value)}
        variant="outlined"
      />
      <Button
        onClick={handleAddGoal}
        variant="contained"
        color="primary"
        style={{ marginTop: 8 }}
      >
        Add Goal
      </Button>
    </Box>
  );
};

export default PlannerSessionGoalsEditor;
